import { Search } from "@mui/icons-material";
import { Box, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

interface IKeyDriveSearchBar {
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    value?: unknown;
}

export const KeyDriveSearchBar : React.FC<IKeyDriveSearchBar> = ({onChange, value}) => {

    const {t} = useTranslation();

    return (
        <Box sx={{
            height: '36px',
            display: 'flex',
            gap: '20px',
            padding: '0px',
        }}>
            <TextField
                fullWidth
                id="filled-basic"
                variant="filled"
                placeholder={t('AdminConsole.WhatAreYouLookingFor')}
                onChange={onChange}
                value={value}
                InputProps={{
                    disableUnderline: true,
                    startAdornment: (
                        <Box sx={{ display: 'flex', alignItems: 'center', paddingRight: '10px', opacity: '0.5' }}>
                            <Search />
                        </Box>
                    ),
                    sx: {
                        height: '36px',
                        padding: '0 10px',
                        '& .MuiFilledInput-input': {
                            height: '36px',
                            padding: '0 10px',
                            display: 'flex',
                            alignItems: 'center',
                        },
                    },
                }}
                sx={{
                    '& .MuiInputBase-root': {
                        height: '36px',
                        backgroundColor: '#f0f0f0',
                        borderRadius: '4px',
                    },
                    '& input::placeholder': {
                        fontSize: '14px',
                        color: '#969696',
                    },
                }}
            />
        </Box>
    )
}